import React, {useEffect, useState} from "react";
import {Modal} from "react-bootstrap";
import FindingGridPreview from "../finding-grid-preview/FindingGridPreview";
import useMain from "../../hooks/useMain";
import useFormParams from "../../hooks/useFormParams";
import _ from "lodash";

const DialogPreviewFinding = props => {
  const {close, templateId, formId, opening, setOpening} = props;

  const {fetchSavedForm, fetchImagesByForm} = useMain();
  const formParamsData = useFormParams(templateId);

  const open = Boolean(templateId);

  const [findings, setFindings] = useState([]);
  const [findingCriticality, setFindingCriticality] = useState([]);
  const [noResults, setNoResults] = useState(false);
  const [findingCategories, setFindingCategories] = useState([]);

  useEffect(() => {
    if (!templateId) return;
    setFindingCriticality(formParamsData.findingCriticality);
    setFindingCategories(formParamsData.findingCategories);
  }, [formParamsData.ready, templateId]);

  useEffect(() => {
    if (!formId || !templateId) {
      setFindings([]);
      setNoResults(false);
      return;
    }

    setOpening(true);
    Promise.all([fetchSavedForm(formId), fetchImagesByForm(formId)])
      .then(result => {
        const _form = result[0];
        const _images = result[1];

        const _findings = _.map(_form.hallazgos, finding => {
          const images = _.get(_images, `images.${finding.HallazgoId}`, []);
          return {...finding, images};
        });

        setNoResults(_findings.length < 1);
        setFindings(_findings);
      })
      .finally(() => setOpening(false));
  }, [formId, templateId]);

  return (
    <Modal
      show={open}
      onHide={() => close()}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Hallazgos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FindingGridPreview
          findings={findings}
          categories={findingCategories}
          imageSize={2}
        />
        {opening && (
          <div className="w-100 d-flex py-3 justify-content-center align-items-center">
            <div className="spinner-border text-secondary" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="ms-3">Cargando...</span>
          </div>
        )}

        {noResults && (
          <div className="text-center fst-italic my-3">
            No se encontraron resultados para la búsqueda.
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => close()}
          disabled={opening}
        >
          Cerrar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default DialogPreviewFinding;
